export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6584.5110e769.jpg";